export function focusOpenedCartDrawerNote(event, schedule = requestAnimationFrame) {
  const details = event.target;
  if (!details?.matches?.('[data-cart-drawer-note]') || !details.open) return;

  const textarea = details.querySelector('textarea');
  if (textarea) schedule(() => textarea.focus());
}

if (typeof document !== 'undefined') {
  document.addEventListener('toggle', focusOpenedCartDrawerNote, true);
  document.addEventListener('alpine:init', () => {
    Alpine.data('ThemeModule_CartNote', () => {
      return {
        updating: false,
        updateNote() {
          this.updating = true;
          fetch(theme.routes.cart_update_url, {
            method: 'POST',
            body: JSON.stringify({
              note: this.$root.value,
            }),
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/json;',
              Accept: 'application/json',
            },
          }).then(() => {
            this.updating = false;
          });
        },
      };
    });
  });
}
